import axios from "axios";
import v2Axios from "../v2Axios";
import { CONFIG } from "../../config";
export const getQuestionService = async (quizID) => {
	try {
		const response = await v2Axios.get(
			`${CONFIG.COURSEURL}/api/v2/quiz/` + quizID
		);
		// console.log(response.data);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return { questions: [], answers: [] };
	}
};

// New function to get quiz questions by lesson ID
export const getQuestionByLessonService = async (lessonId) => {
	try {
		const response = await axios.get(
			`${CONFIG.SCHOOLURL}/quiz-questions/get-by-lesson/${lessonId}`
		);
		return response.data;
	} catch (error) {
		console.error("Error fetching quiz questions by lesson:", error);
		return { questions: [], answers: [] };
	}
};
